module.exports = __webpack_public_path__ + "media/illBeHere2.70bf0a87.mp3";